import request from '@/utils/request'

// getDwgCountByPO
export function getDwgCountByPO(param) {
  let data = param
  return request({
    url: `/common/getDwgCountByPO`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getDwgListByPO
export function getDwgListByPO(param) {
  let data = param
  return request({
    url: `/common/getDwgListByPO`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getDwgCountByQuot
export function getDwgCountByQuot(param) {
  let data = param
  return request({
    url: `/common/getDwgCountByQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getDwgListByQuot
export function getDwgListByQuot(param) {
  let data = param
  return request({
    url: `/common/getDwgListByQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getDwgCountByPor
export function getDwgCountByPor(param) {
  let data = param
  return request({
    url: `/common/getDwgCountByPor`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getDwgListByPor
export function getDwgListByPor(param) {
  let data = param
  return request({
    url: `/common/getDwgListByPor`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getShipNoList1
export function getShipNoList1(param) {
  let data = param
  return request({
    url: `/common/getShipNoList1`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// epms9000_block
export function epms9000_block(param) {
  let data = param
  return request({
    url: `/common/epms9000_block`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// epms9000_por_no
export function epms9000_por_no(param) {
  let data = param
  return request({
    url: `/common/epms9000_por_no`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function reportView(param) {
  let data = param

  return request({
    url: `/common/reportView`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('res', res)
    
    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/pdf' })
    const blobURL = URL.createObjectURL(blob)
    window.open(blobURL, "", "width=1024, height=700, scrollbars=no, directories=no, location=no, menubar=no, resizable=no, status=yes, toolbar=no")
    })
}

export function ftpDownload(url, fileName) {
  const filePath = url.replace(/http:\/\/192.168.50.11\//g, '').replace(/http:\/\/ebiz.hvs.com.vn\//g, '')
  const orgFileNameArr = filePath.split('/')
  const orgFileName = orgFileNameArr[orgFileNameArr.length - 1]
  const extension = orgFileName.split('.')

  console.log('filePath2', filePath.replace(/\//g, '\\'))

  return request({
    url: `/ftpDownload/${filePath.replace(/\//g, '\\')}`,
    method: 'GET',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }
  }).then(res => {
    // console.log('res', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }

    const blob = new Blob([bytes])
    const blobURL = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobURL

    if(fileName) {
      link.download = `${fileName}.${extension[1]}`
    } else {
      link.download = orgFileName
    } 

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  })
}

export function fileDownload(param) {
  // filePath(required), fileName(not required)
  let data = param

  return request({
    url: `/common/fileDownload`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('res', res)
    
    const binaryString = window.atob(res.file)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    // const blob = new Blob([bytes], { type: res.fileType })
    // if(res.fileType.toUpperCase() === 'PDF') {
    //   const blob = new Blob([bytes], { type: 'application/pdf' })
    //   const blobURL = URL.createObjectURL(blob)
    //   window.open(blobURL, "/")
    // } else {
      const blob = new Blob([bytes])
      const blobURL = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobURL

      if(param.fileName) {
        link.download = `${param.fileName}.${res.fileType}`
      } else {
        link.download = res.fileName
      } 

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
    // }
  })
}

export function getRequestList(param) {
  let data = param
  return request({
    url: `/common/getRequestList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getWasteSellList(param) {
  let data = param
  return request({
    url: `/common/getWasteSellList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function goReceive(param) {
  let data = param
  return request({
    url: `/common/goReceive`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getQuotNoList
export function getQuotNoList(param) {
  let data = param
  return request({
    url: `/common/getQuotNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getQuotNoOutList
export function getQuotNoOutList(param) {
  let data = param
  return request({
    url: `/common/getQuotNoOutList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getRequestHead
export function getRequestHead(param) {
  let data = param
  return request({
    url: `/common/getRequestHead`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getRequestDetail
export function getRequestDetail(param) {
  let data = param
  return request({
    url: `/common/getRequestDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getPipeQuotYn
export function getPipeQuotYn(param) {
  let data = param
  return request({
    url: `/common/getPipeQuotYn`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getPipeYn
export function getPipeYn(param) {
  let data = param
  return request({
    url: `/common/getPipeYn`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSave1020Check
export function getSave1020Check(param) {
  let data = param
  return request({
    url: `/common/getSave1020Check`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSubmitDetail
export function getSubmitDetail(param) {
  let data = param
  return request({
    url: `/common/getSubmitDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSubmitDetail1
export function getSubmitDetail1(param) {
  let data = param
  return request({
    url: `/common/getSubmitDetail1`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSubmitFile
export function getSubmitFile(param) {
  let data = param
  return request({
    url: `/common/getSubmitFile`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getPrintRequestSheetA
export function getPrintRequestSheetA(param) {
  let data = param
  return request({
    url: `/common/getPrintRequestSheetA`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getQuotStep
export function getQuotStep(param) {
  let data = param
  return request({
    url: `/common/getQuotStep`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getAcc
export function getAcc(param) {
  let data = param
  return request({
    url: `/common/getAcc`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getAccCd
export function getAccCd(param) {
  let data = param
  return request({
    url: `/common/getAccCd`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getAccGrp
export function getAccGrp(param) {
  let data = param
  return request({
    url: `/common/getAccGrp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// setSubmit1020ACC
export function setSubmit1020ACC(param) {
  let data = param
  return request({
    url: `/common/setSubmit1020ACC`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// delete1020ACC
export function delete1020ACC(param) {
  let data = param
  return request({
    url: `/common/delete1020ACC`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// setSave1020Det
export function setSave1020Det(param) {
  let data = param
  return request({
    url: `/common/setSave1020Det`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// setSubmit1020Det
export function setSubmit1020Det(param) {
  let data = param
  return request({
    url: `/common/setSubmit1020Det`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getSysDate
export function getSysDate(param) {
  let data = param
  return request({
    url: `/common/getSysDate`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getCarList
export function getCarList(param) {
  let data = param
  return request({
    url: `/common/getCarList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getDriverList
export function getDriverList(param) {
  let data = param
  return request({
    url: `/common/getDriverList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// executeDwgViewer
export function getDwgTicket(param) {
  let data = param
  return request({
    url: `/common/getDwgTicket`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getCheckSurvey
export function getCheckSurvey(param) {
  let data = param
  return request({
    url: `/common/getCheckSurvey`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getSurveyQuest
export function getSurveyQuest(param) {
  let data = param
  return request({
    url: `/common/getSurveyQuest`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getSurveyResult
export function getSurveyResult(param) {
  let data = param
  return request({
    url: `/common/getSurveyResult`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// setSubmitSurvey
export function setSubmitSurvey(param) {
  let data = param
  return request({
    url: `/common/setSubmitSurvey`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}